import React from 'react';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { BTN_OUTLINED_SX } from '../styles/reportPageStyles';

const PageBackButton = ({ onClick, sx }) => (
  <Button
    onClick={onClick}
    endIcon={<ArrowBackIcon sx={{ fontSize: 18 }} />}
    sx={{
      ...BTN_OUTLINED_SX,
      bgcolor: 'rgba(255, 255, 255, 0.96)',
      backdropFilter: 'blur(10px)',
      boxShadow: '0 6px 24px rgba(50, 51, 56, 0.18)',
      px: 2,
      py: 1,
      '& .MuiButton-endIcon': {
        marginLeft: 0,
        marginRight: 1,
      },
      ...sx,
    }}
  >
    بازگشت
  </Button>
);

export default PageBackButton;
